import HiwComparison from './HiwComparison';

export default HiwComparison;
